import { type SampleDeckNames, sampleDeckNames } from "@convex/SAMPLE_DECKS";

export function getRandomSampleDeckName(
  existingDeckNames: string[],
  remainingSampleDeckNames: string[] = sampleDeckNames
) {
  if (remainingSampleDeckNames.length === 0) {
    // If there are no more sample deck names to choose from, return undefined.
    return undefined;
  }
  const randomIndex = Math.floor(Math.random() * remainingSampleDeckNames.length);
  const attempt = remainingSampleDeckNames[randomIndex] as SampleDeckNames;
  if (existingDeckNames.includes(attempt)) {
    // If the name already exists, and there are other names to choose from, try again.
    return getRandomSampleDeckName(
      existingDeckNames,
      remainingSampleDeckNames.filter((name) => name !== attempt)
    );
  }
  return attempt;
}
